<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    transition="scale-transition"
    min-width="auto"
    offset-y
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        :value="displayDate"
        v-bind="$attrs"
        v-on="on"
        :class="inputClass"
        :style="inputStyle"
        class="p-date-picker-text"
        readonly
        @click:clear="date=null"
        @click="$emit('click')"
      ></v-text-field>
    </template>
    <v-date-picker
      v-model="date"
      :min="minDate"
      :show-current="showCurrent"
      color="primary"
      no-title
      @input="menu = false"
      @change="$emit('change')"
    ></v-date-picker>
  </v-menu>
</template>


<script>
import moment from 'moment'
import { dateTimeFormats } from '@/constants'


export default {
  inheritAttrs: false,


  props: {
    value: {
      type: String
    },
    min: {
      type: String
    },
    inputClass: {
      type: String
    },
    inputStyle: {
      type: String
    },
    showCurrent: {
      type: String
    }
  },


  data () {
    return {
      menu: false
    }
  },


  computed: {
    date: {
      get () {
        return this.value ? moment.utc(this.value).format(dateTimeFormats.datePicker) : null
      },
      set (val) {
        this.$emit('input', val)
      }
    },

    minDate () {
      return this.min ? moment.utc(this.min).format(dateTimeFormats.datePicker) : null
    },

    displayDate () {
      return this.date ? moment.utc(this.date).format('ll') : ''
    }
  },


  watch: {
    min: {
      handler (min) {
        if (min) {
          if (moment.utc(this.date).isBefore(this.minDate, 'day')) {
            this.date = this.minDate
          }
        }
      },
      immediate: true
    }
  }
}
</script>
